<div class="header-bar">
  <div class="header-left"></div>
  <div class="header-center">{{ isEdit ? "Edit App" : "Add New App" }}</div>
  <div class="header-right">
    <button mat-button color="fiord" (click)="cancel()">Cancel</button>
    <button *ngIf="!isEdit" mat-button color="lightGreen" (click)="createApp()">
      Add new app
    </button>
    <button *ngIf="isEdit" mat-button color="lightGreen" (click)="updateApp()" [disabled]="appForm!.invalid || demoForm!.invalid">
      Update app
    </button>
  </div>
</div>
<div class="account-app">
  <div class="container app-details-container">
    <div class="container-header no-bottom-border">
      <div class="text">App details</div>
    </div>
    <div class="container-content">
      <div class="info">
        <lhpe-input
          class="input"
          controlName="appName"
          placeholder="App name"
          [formGroup]="appForm!"
          [required]="true"
        >
        </lhpe-input>
      </div>

      <div class="info">
        <div class="label">Platforms</div>
        <div class="checkbox-group">
          <div class="checkbox" *ngFor="let platform of platforms">
            <mat-checkbox
              [(ngModel)]="platform.selected"
              color="lightGreen"
              labelPosition="before"
              >{{ platform.name }}</mat-checkbox
            >
          </div>
        </div>
      </div>

      <div *ngIf="iOSSelected" class="info">
        <div class="label">iOS info</div>
        <div class="row">
          <lhpe-input
            class="input"
            controlName="bundleID"
            placeholder="iOS app bundle ID"
            [formGroup]="iOSForm!"
          >
          </lhpe-input>
        </div>
        <div class="row">
          <lhpe-input
            class="input"
            controlName="key"
            placeholder="Key"
            [formGroup]="iOSForm!"
          >
          </lhpe-input>
        </div>
        <div class="row">
          <div class="quarter">
            <lhpe-input
              class="input"
              controlName="keyID"
              placeholder="Key ID"
              [formGroup]="iOSForm!"
            >
            </lhpe-input>
          </div>
          <div class="quarter">
            <lhpe-input
              class="input"
              controlName="teamID"
              placeholder="Team ID"
              [formGroup]="iOSForm!"
            >
            </lhpe-input>
          </div>
          <mat-radio-group
            class="mat-lightGreen mode-group"
            [value]="iOSForm.controls.mode.value"
            aria-label="Select a service level"
          >
            <mat-radio-button class="mat-lightGreen" value="sandbox"
              >Sandbox</mat-radio-button
            >
            <mat-radio-button class="mat-lightGreen" value="production">
              Production</mat-radio-button
            >
          </mat-radio-group>
        </div>
      </div>
      <div *ngIf="androidSelected" class="info">
        <div class="label">Android info</div>
        <div class="row">
          <lhpe-input
            class="input"
            controlName="mesgIDKey"
            placeholder="Google Cloud Messaging ID key"
            [formGroup]="googleForm!"
          >
          </lhpe-input>
        </div>
      </div>
      <div class="info">
        <div class="label">Firebase info</div>
        <div class="row">
          <lhpe-input
            class="input"
            controlName="firebaseConfig"
            placeholder="Firebase config"
            [formGroup]="webForm!"
          >
          </lhpe-input>
        </div>
      </div>
      <!-- <div *ngIf="webSelected" class="info">
        <div class="label">Chrome info</div>
        <div class="row">
          <lhpe-input
            class="input"
            controlName="chromeConfig"
            placeholder="Chrome config"
            [formGroup]="webForm!"
          >
          </lhpe-input>
        </div>
      </div>
      <div *ngIf="webSelected" class="info">
        <div class="label">Safari info</div>
        <div class="row">
          <lhpe-input
            class="input"
            controlName="safariConfig"
            placeholder="Safari info"
            [formGroup]="webForm!"
          >
          </lhpe-input>
        </div>
      </div> -->
    </div>
  </div>

  <!-- API Credentials Section - Only show when editing existing app -->
  <div *ngIf="isEdit" class="container api-credentials-container">
    <div class="container-header no-bottom-border">
      <div class="text">API Credentials</div>
    </div>
    <div class="container-content">
      <div class="info">
        <div class="label">API ID</div>
        <div class="readonly-field">
          <input 
            type="text" 
            [value]="app?.api_id" 
            readonly 
            class="readonly-input"
            #apiIdInput
          >
          <button 
            mat-button 
            class="copy-btn" 
            (click)="copyToClipboard(apiIdInput.value, 'API ID')"
            title="Copy API ID to clipboard"
          >
            <svg-icon src="assets/svg/clipboard-pencil.svg" svgClass="lightBlue"></svg-icon>
          </button>
        </div>
      </div>

      <div class="info">
        <div class="label">API Key</div>
        <div class="readonly-field">
          <input 
            type="text" 
            [value]="app?.api_key" 
            readonly 
            class="readonly-input"
            #apiKeyInput
          >
          <button 
            mat-button 
            class="copy-btn" 
            (click)="copyToClipboard(apiKeyInput.value, 'API Key')"
            title="Copy API Key to clipboard"
          >
            <svg-icon src="assets/svg/clipboard-pencil.svg" svgClass="lightBlue"></svg-icon>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="container service-level-container">
    <div class="container-header no-bottom-border">
      <div class="text">Subscription</div>
    </div>
    <div class="container-content">
      <div class="row">
        Service level:
        <span
          class="service-level"
          [ngClass]="{ 'not-available': !serviceLevel }"
          >{{ serviceLevel ? serviceLevel : "N/A" }}</span
        >
      </div>

      <div *ngIf="!serviceLevel && isAccountAdmin" class="row">
        <button mat-button color="lightGreen">Subscribe now</button>
      </div>
      <div *ngIf="serviceLevel && isSuper" class="row">
        <button mat-button color="fiord">Manage Stripe account</button>
      </div>
    </div>
  </div>

  <div class="container demo-container">
    <div class="container-header no-bottom-border">
      <div class="text">Demo Mode</div>
    </div>
    <div class="container-content" [formGroup]="demoForm">

      <div class="row">
        <mat-checkbox
          color="lightGreen"
          labelPosition="after"
          formControlName="demo_mode"
          >Enable demo mode</mat-checkbox>
      </div>

      <div class="row" *ngIf="demoForm.value.demo_mode">
        <lhpe-input
            class="input"
            controlName="demo_freq_num"
            placeholder=""
            [formGroup]="demoForm!"
            type="number"
          >
          </lhpe-input>
        <lhpe-select
            class="quarter-input"
            controlName="demo_freq_interval"
            placeholder=""
            [formGroup]="demoForm!"
            [options]="intervalOptions"
            [optionIsSelf]="true"
            [displayValue]="'name'"
          ></lhpe-select>
      </div>

      <div class="row" *ngIf="demoForm.value.demo_mode">
        <lhpe-input
            class="input"
            type="number"
            controlName="sim_device"
            placeholder="Installs Weight"
            [formGroup]="demoForm!"
          >
        </lhpe-input>
      </div>

      <div class="row" *ngIf="demoForm.value.demo_mode">
        <lhpe-input
            class="input"
            type="number"
            controlName="sim_reg"
            placeholder="Registrations Weight"
            [formGroup]="demoForm!"
          >
        </lhpe-input>
      </div>

      <div class="row" *ngIf="demoForm.value.demo_mode">
        <lhpe-input
            class="input"
            type="number"
            controlName="sim_geo_enter"
            placeholder="Geofence Entry Weight"
            [formGroup]="demoForm!"
          >
        </lhpe-input>
      </div>

      <div class="row" *ngIf="demoForm.value.demo_mode">
        <lhpe-input
            class="input"
            type="number"
            controlName="sim_geo_exit"
            placeholder="Geofence Exit Weight"
            [formGroup]="demoForm!"
          >
        </lhpe-input>
      </div>

      <div class="row" *ngIf="demoForm.value.demo_mode">
        <lhpe-input
            class="input"
            type="number"
            controlName="sim_br_enter"
            placeholder="Beacon Region Entry Weight"
            [formGroup]="demoForm!"
          >
        </lhpe-input>
      </div>

      <div class="row" *ngIf="demoForm.value.demo_mode">
        <lhpe-input
            class="input"
            type="number"
            controlName="sim_br_exit"
            placeholder="Beacon Region Exit Weight"
            [formGroup]="demoForm!"
          >
        </lhpe-input>
      </div>

      <div class="row" *ngIf="demoForm.value.demo_mode && sims.length > 0">
        Demo will run every {{ demoForm.value.demo_freq_num }} {{ demoForm.value.demo_freq_interval.name }}
      </div>

      <div class="row" *ngIf="demoForm.value.demo_mode && sims.length == 0">
        Demo will not run without any simulators
      </div>

    </div>
  </div>

</div>
